export default __webpack_public_path__ + "static/media/persotypesNantes-1.3f168f09.pdf";